export default {
  title: 'Примеры шаблонов WhatsApp',
  subtitle:
    'Вы можете отредактировать и отправить на регистрацию любой из шаблонов ниже. Для этого выберите подходящую отрасль и тему сообщения',
  searchPlaceholder: 'поиск по названию или тексту',
  totalCount: 'Всего примеров – {{count}}',
  totalSearch: 'Примеров по критериям – {{count}}',
  filters: {
    industry: 'Отрасль',
    topic: 'Тема сообщения',
  },
  notFound: {
    title: 'Увы, мы ничего не нашли',
    subtitle: 'В библиотеке пока нет шаблонов с такими параметрами',
    hint: 'Выберите другие фильтры или создайте свой шаблон',
    action: 'Создать шаблон',
  },
  registrationModal: {
    title: 'Пример “{{name}}”',
    subTitle: 'Чтобы изменить содержание шаблона, нажмите "Редактировать шаблон" и следуйте шагам',
    showExample: 'Показать пример',
    name: 'Название шаблона',
    nameHint:
      'В названии можно использовать только латинские буквы, цифры и подчеркивания (_). Другие символы и пробелы не допускаются',
    subject: 'Отправитель (аккаунт WhatsApp), на которого будет зарегистрирован шаблон',
    wabaHint:
      'По правилам Facebook шаблон регистрируется на вашу учетную запись WABA. После регистрации шаблон будет доступен для всех имен отправителей, привязанных к этой учетной записи WABA: ',
    linkButton: 'Кнопка со ссылкой',
    linkButtonHint:
      'Ссылка на кнопке может быть статической (фиксированной) или динамической. Динамическая должна состоять из двух частей. Первая – неизменяемая (например, раздел сайта https://example.com/marketing/). ' +
      'Вторая, конечная часть ссылки, может меняться для каждой рассылки, созданной с помощью этого шаблона (например, https://example.com/marketing/<b>action234</b> или https://example.com/marketing/<b>gift-1000</b>).<br/>' +
      'В рассылке вы также сможете сделать динамическую ссылку индивидуальной для каждого получателя, если добавите в конце необходимую переменную. ',
    addUrl: 'Добавьте ссылки для кнопки',
    buttonText: 'Текст кнопки: <0>{{text}}</0>',
    staticUrl: 'Статическая ссылка (до 2 000 символов)',
    dynamicUrl: 'Сделать ссылку кнопки динамической',
    collectClicks: 'Отслеживать переходы по кнопке-ссылке',
    collectClicksHint:
      'Ссылка в сообщении заменяется индивидуально для каждого получателя. Срок действия ссылки истекает через 30 дней после отправки сообщения',
    phoneButton: 'Кнопка-звонок',
    addPhone: 'Добавьте номер телефона для кнопки',
    phone: 'Номер телефона с плюсом и кодом страны, например, +74951234567.',
    registerButton: 'Отправить на регистрацию',
    editButton: 'Редактировать шаблон',
  },
  successModal: {
    title: 'Шаблон отправлен на регистрацию',
    subtitle:
      'Регистрация такого шаблона займет несколько минут. Следите за обновлением статуса шаблона — совсем скоро вы сможете отправлять по нему рассылки',
  },
  editModal: {
    title: 'Редактировать шаблон?',
    subtitle:
      'Вы можете изменить любой параметр шаблона, но после этого его надо отправить на проверку',
  },
};
